import { render, staticRenderFns } from "./Gamification.vue?vue&type=template&id=f8213956&scoped=true&"
import script from "./Gamification.vue?vue&type=script&lang=js&"
export * from "./Gamification.vue?vue&type=script&lang=js&"
import style0 from "./Gamification.vue?vue&type=style&index=0&id=f8213956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8213956",
  null
  
)

export default component.exports